import { createContext, useContext } from "react";
import { DEFAULT_SETTINGS } from "./constants";

export const SettingsCtx = createContext(DEFAULT_SETTINGS);

export const useSettings = () => useContext(SettingsCtx);
